const defaultConfig = {
  itemsKey: "promotional_carousel",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props: (*&{items: *})}|null}
 */
export const promotionalCarousel = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || !(page[config.itemsKey].length > 0)) {
    return null;
  }

  return {
    component: "PromotionalCarousel",
    props: {
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
        description: i.description ?? null,
        img: i.image ?? null,
        video_embed_url: i.video_embed_url ?? null,
        cta: i.button_url
          ? {
              label: i.button_label ?? "Read more",
              href: i.button_url ?? "#",
              variant: "tertiary",
            }
          : null,
      })),
      ...props,
    },
  };
};
